import React from "react";

export const AccessibleButton = ({ element: Element = 'div', onClick, ...otherProps }) => {
  // https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
  const keyDown = (event) => {
    // The action button is activated by space on the keyup event, but the
    // default action for space is already triggered on keydown. It needs to be
    // prevented to stop scrolling the page before activating the button.
    if (event.keyCode === 32) {
      event.preventDefault();
    }
    // If enter is pressed, activate the button
    else if (event.keyCode === 13) {
      event.preventDefault();
      onClick(event);
    }
  }

  const keyUp = (event) => {
    if (event.keyCode === 32) {
      event.preventDefault();
      onClick(event);
    }
  }

  return (
    <Element role="button" tabIndex="0" onClick={onClick} onKeyDown={keyDown} onKeyUp={keyUp} {...otherProps} />
  )
}